import update from 'immutability-helper';
import { Orientation } from '@marvelapp/core';
import * as actionTypes from '../constants/actionTypes';
export default function devToolsReducer(state, action) {
    switch (action.type) {
        case actionTypes.CHANGE_PROJECT_DEVICE_FRAME: {
            var name_1 = action.frame;
            return update(state, {
                project: {
                    config: {
                        device: {
                            frame: { $set: name_1 },
                            orientation: { $set: Orientation.Portrait },
                        },
                    },
                },
            });
        }
        case actionTypes.CHANGE_PROJECT_DEVICE_ORIENTATION:
            return update(state, {
                project: {
                    config: {
                        device: {
                            orientation: { $set: action.orientation },
                        },
                    },
                },
            });
        case actionTypes.CHANGE_DEVICE_ORIENTATION:
            return update(state, {
                device: {
                    orientation: { $set: action.orientation },
                },
            });
        case actionTypes.CHANGE_DEVICE_DETECTION:
            return update(state, {
                deviceDetection: { $merge: action.deviceDetection },
            });
        case actionTypes.SET_PROJECT_PLAN:
            return update(state, {
                project: {
                    config: {
                        plan: { $set: action.plan },
                    },
                },
            });
        default:
            return state;
    }
}
